import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import { Modal } from "react-bootstrap";

import { Translator } from "../../../utils/translator";
import { QuotaAPI } from "../../../api";
import { success, error } from "../../structure/Alert";
import Card from "../../structure/Card";
import * as AppActions from "../../../reducers/appReducer";

const helpText = Translator.getHelpText("en", "profilePaymentMethod");

interface IPaymentMethodProps {
  appActions: any;
  history: any;
  title?: string;
  setPaymentMethodStatus?: (hasPaymentMethod: boolean) => void;
}

interface IPaymentMethodState {
  loading: boolean;
  name: string;
  number: string;
  expirationMonth: string;
  expirationYear: string;
  cvc: string;
  showRemoveModal: boolean;
  hasMethod: boolean;
  currentMethod: {
    expiresMonth: string;
    expiresYear: string;
    lastFour: string;
  };
}

class PaymentMethod extends React.Component<IPaymentMethodProps, IPaymentMethodState> {

  constructor(props: any){
    super(props);
    this.state = {
      loading: false,
      name: "",
      number: "",
      expirationMonth: moment().format("MM"),
      expirationYear: moment().format("YY"),
      cvc: "",
      showRemoveModal: false,
      hasMethod: false,
      currentMethod: {
        expiresMonth: "",
        expiresYear: "",
        lastFour: ""
      }
    };

    this.getCurrentPaymentMethod = this.getCurrentPaymentMethod.bind(this);
    this.updateField = this.updateField.bind(this);
    this.updatePaymentMethod = this.updatePaymentMethod.bind(this);
    this.toggleRemovePaymentMethodModal = this.toggleRemovePaymentMethodModal.bind(this);
    this.createCardString = this.createCardString.bind(this);
  }

  componentDidMount(){
    this.getCurrentPaymentMethod();
  }

  public render() {
    return (
      <Card title={this.props.title ? this.props.title : "Payment Method"} loading={this.state.loading} help={helpText}>
        {this.state.hasMethod ?
          (<div><p className="bg-success" style={{ textAlign: "center", padding: 5, color: "white" }}><strong>{this.createCardString()}</strong></p>
            <div className="row">
              <div className="col-md-12">
                <p><strong>Use the form below to replace the existing card</strong></p>
              </div>
            </div></div>) :
          (<div className="bg-danger" style={{ textAlign: "center", padding: 5, color: "white" }}><strong>No payment method on file!</strong></div>)}
        <div className="row" style={{marginTop: 15}}>
          <div className="col-md-12">
            <div className="form-group">
              <label>Name on Card</label>
              <input type="text" id="name" value={this.state.name} onChange={this.updateField} className="form-control" placeholder="The Name On The Card" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>Card Information</label>
              <input type="text" id="number" value={this.state.number} onChange={this.updateField} className="form-control" placeholder="The Credit Card Number" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <select id="expirationMonth" value={this.state.expirationMonth} onChange={this.updateField} className="form-control">
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <select id="expirationYear" value={this.state.expirationYear} onChange={this.updateField} className="form-control">                
                {this.getYearOptions()}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <input type="text" id="cvc" value={this.state.cvc} onChange={this.updateField} className="form-control" placeholder="CVC" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button className="btn btn-block btn-primary" onClick={this.updatePaymentMethod}>Update Payment Method</button>
          </div>
        </div>

        <Modal show={this.state.showRemoveModal} onHide={this.toggleRemovePaymentMethodModal} backdrop="static">
          <Modal.Header closeButton={true}>
            <Modal.Title>Are you sure?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you absolutely sure you want to delete this payment method? Any existing or future invoices will not be able to automatically charge
            until a new payment method is provided.

          </Modal.Body>
          <Modal.Footer>
              <div className="col-6">
                <button className="btn btn-danger" onClick={this.toggleRemovePaymentMethodModal}>Yes, Remove Their Payment Method</button>
              </div>
              <div className="col-6">
                <button className="btn btn-primary" onClick={this.toggleRemovePaymentMethodModal}>Cancel</button>
              </div>
          </Modal.Footer>
        </Modal>
      </Card>
    );
  }

  private updateField(e: any) {
    const ns: any = this.state;
    ns[e.target.id] = e.target.value;
    this.setState(ns);
  }

  private async updatePaymentMethod() {
    this.setState({ loading: true }, async () => {

      (window as any).Stripe.card.createToken({
        number: this.state.number,
        cvc: this.state.cvc,
        exp_month: this.state.expirationMonth,
        exp_year: this.state.expirationYear
      }, async (status: any, response: any) => {
        if (status !== 200) {
          return this.setState({ loading: false }, () => {
            return error("Could not save that payment information");
          });
        }

        try {
          const data = {
            token: response.id,
            methodType: "card"
          };
          await QuotaAPI.changePaymentMethod(data);
          return this.setState({ loading: false, hasMethod: true, number: "", name: "" }, () => {
            success("Payment information updated");
            this.getCurrentPaymentMethod();
          });
        } catch (err) {
          return this.setState({ loading: false }, () => {
            return error("Could not save that payment method");
          });
        }
      });
    });

  }

  private toggleRemovePaymentMethodModal() {
    this.setState({ showRemoveModal: !this.state.showRemoveModal });
  }

  private async getCurrentPaymentMethod() {
    this.setState({ loading: true }, async () => {
      try {
        const paymentRes = await QuotaAPI.getPaymentMethod();
        this.setState({
          loading: false,
          hasMethod: true,
          currentMethod: {
            lastFour: paymentRes.body.data.card.lastFour,
            expiresMonth: paymentRes.body.data.card.expiresMonth,
            expiresYear: paymentRes.body.data.card.expiresYear
          },
        }, () => {
          if(this.props.setPaymentMethodStatus){
            this.props.setPaymentMethodStatus(true);
          }
        });
      } catch (err) {
        this.setState({
          loading: false,
          hasMethod: false
        }, () => {
          if(this.props.setPaymentMethodStatus){
            this.props.setPaymentMethodStatus(false);
          }
        });
      }
    });
  }

  private createCardString() {
    if (this.state.currentMethod.lastFour === "") {
      return "Card On File But Unknown";
    }
    return `Ends in ${this.state.currentMethod.lastFour} Expiring ${this.state.currentMethod.expiresMonth}/${this.state.currentMethod.expiresYear}`;
  }

  private getYearOptions() {
    const year = moment().year();
    const ret = [];
    for(let i = year; i < year + 10; i++){
      ret.push(<option value={i}>{i}</option>)
    }
    return ret;
  }

}


const mapStateToProps = function map(s: any) {
  return {
    appState: s.appState
  };
};

function mapDispatchToProps(dispatch: any) {
  return {
    appActions: bindActionCreators(AppActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethod) as any;